import React from 'react';
import { MapPin, Calendar, Briefcase } from 'lucide-react';
import './Experience.css';

const Experience = () => {
  const experiences = [
    {
      company: 'Bonx',
      location: 'Paris',
      period: 'Déc. 2025 – Jan. 2026',
      title: 'Pentester',
      description: [
        'Bug bounty sur applications web & API',
        'Identification/validation de vulnérabilités + reporting détaillé + mitigations',
        'Collaboration à distance avec équipes techniques',
        'Tests manuels, scans automatisés, exploitation contrôlée & responsable',
        'Respect strict de la confidentialité et de la disclosure'
      ]
    },
    {
      company: 'Nicomatic',
      location: 'France',
      period: 'Sep. 2024 – Jan. 2026',
      title: 'Administrateur réseaux/systèmes/sécurité',
      description: [
        'Analyse de risques sur systèmes industriels',
        'Évolutions d\'architecture réseau (VLAN, DMZ)',
        'Configuration switch/firewall, MCO SI',
        'Administration AD, gestion serveurs vSphere'
      ]
    },
    {
      company: 'Nicomatic India Electronics',
      location: 'Bangalore',
      period: 'Août 2023 – Nov. 2023',
      title: 'Network Administrator',
      description: [
        'Administration réseau et systèmes',
        'Support technique',
        'Gestion d\'infrastructure IT'
      ]
    }
  ];

  return (
    <main className="experience-page">
      <section className="page-hero">
        <div className="container">
          <h1 className="page-title">Expériences</h1>
          <p className="page-subtitle">
            Parcours professionnel en cybersécurité et administration systèmes.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="timeline">
            {experiences.map((exp, index) => (
              <div key={index} className="timeline-item">
                <div className="timeline-marker"></div>
                <div className="timeline-content">
                  <div className="exp-header">
                    <div>
                      <h3 className="exp-title">{exp.title}</h3>
                      <h4 className="exp-company">{exp.company}</h4>
                    </div>
                    <div className="exp-meta">
                      <div className="exp-meta-item">
                        <MapPin size={16} />
                        <span>{exp.location}</span>
                      </div>
                      <div className="exp-meta-item">
                        <Calendar size={16} />
                        <span>{exp.period}</span>
                      </div>
                    </div>
                  </div>
                  <ul className="exp-description">
                    {exp.description.map((item, idx) => (
                      <li key={idx}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default Experience;